import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export interface AuditRow {
  id: string;
  ts: string;
  user_id: string | null;
  user_email: string | null;
  action: string;
  server_id: string | null;
  server_name: string | null;
  db_name: string | null;
  payload: unknown;
  response: unknown;
  success: boolean;
  ip: string;
  user_agent: string;
}

export interface AuditQuery {
  user_id?: string;
  action?: string;
  server_id?: string;
  from?: string;
  to?: string;
  page?: number;
  page_size?: number;
}

function qs(o: object): string {
  const sp = new URLSearchParams();
  for (const [k, v] of Object.entries(o)) {
    if (v !== undefined && v !== '' && v !== null) sp.set(k, String(v));
  }
  const s = sp.toString();
  return s ? `?${s}` : '';
}

export function useAudit(query: AuditQuery) {
  return useQuery({
    queryKey: ['audit', query],
    queryFn: () =>
      api<{ rows: AuditRow[]; page: number; page_size: number; total: number }>(
        `/audit${qs(query)}`,
      ),
    placeholderData: (prev) => prev,
  });
}

export function auditCsvUrl(query: AuditQuery): string {
  const base = (import.meta.env.VITE_API_URL ?? '/api').replace(/\/$/, '');
  return `${base}/audit/export.csv${qs(query)}`;
}
